module.exports = __webpack_public_path__ + "static/img/driving_back.a001286.png";